// Mock data for Clean24 booking app

export const ASSETS = {
  logo: 'https://customer-assets-agu9un31.emergentagent.net/job_4e3b581e-2571-40f8-8f31-934fef60c77c/artifacts/dyjui8t8_WhatsApp%20Image%202026-07-09%20at%203.51.13%20PM%20%283%29.jpeg',
  team: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/c3am4tdi_group%20photo.jpeg',
  staff: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/fk24vgaw_staff.jpeg',
  dishClean: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/3y721prf_dish%20clean.jpeg',
  fanClean: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/a0ycwnff_fan%20clean.jpeg',
  bedChange: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/qzhisg73_bed%20change.jpeg',
  waterTank: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/ffig11hp_water%20tank%20clean.jpeg',
  wallClean: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/3mssse9j_wall%20clean.jpeg',
  toiletClean: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/xqdlh8bp_toilet%20clean.jpeg',
  sinkClean: 'https://customer-assets-jt897jd0.emergentagent.net/job_booking-portal-185/artifacts/by6ykqhy_sink%20clean.jpeg',
  homeCleaning: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&auto=format&fit=crop',
  deepCleaning: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?w=800&auto=format&fit=crop',
  officeCleaning: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&auto=format&fit=crop',
  apartmentCleaning: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&auto=format&fit=crop',
  glassCleaning: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&auto=format&fit=crop',
  corporateOffice: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800&auto=format&fit=crop',
  showroomCleaning: 'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=800&auto=format&fit=crop',
  apartmentSociety: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&auto=format&fit=crop',
  plumber: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800&auto=format&fit=crop',
  electrician: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=800&auto=format&fit=crop',
  switchboard: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&auto=format&fit=crop',
};

export const CATEGORIES = [
  { id: 'home-cleaning', name: 'Home Cleaning', tag: 'Hourly', price: 399, image: ASSETS.sinkClean, icon: 'Home' },
  { id: 'deep-cleaning', name: 'Deep Cleaning', tag: 'Hourly', price: 399, image: ASSETS.wallClean, icon: 'Sparkles' },
  { id: 'office-cleaning', name: 'Office Cleaning', tag: 'Hourly', price: 399, image: ASSETS.officeCleaning, icon: 'Building2' },
  { id: 'apartment-cleaning', name: 'Apartment Cleaning', tag: 'Hourly', price: 399, image: ASSETS.apartmentCleaning, icon: 'BedDouble' },
  { id: 'glass-cleaning', name: 'Glass Cleaning', tag: 'Hourly', price: 399, image: ASSETS.glassCleaning, icon: 'PanelTop' },
  { id: 'water-tank-cleaning', name: 'Water Tank Cleaning', tag: 'Hourly', price: 399, image: ASSETS.waterTank, icon: 'Droplet' },
  { id: 'corporate-office', name: 'Corporate Office', tag: 'Hourly', price: 399, image: ASSETS.corporateOffice, icon: 'Briefcase' },
  { id: 'showroom-cleaning', name: 'Showroom Cleaning', tag: 'Hourly', price: 399, image: ASSETS.showroomCleaning, icon: 'Store' },
  { id: 'apartment-society', name: 'Apartment Society', tag: 'Hourly', price: 399, image: ASSETS.apartmentSociety, icon: 'Users' },
  { id: 'sofa-cleaning', name: 'Sofa Cleaning', tag: 'Hourly', price: 499, image: ASSETS.bedChange, icon: 'Sofa' },
  { id: 'plumber-service', name: 'Plumber Service', tag: 'Per visit', price: 199, image: ASSETS.plumber, icon: 'Wrench' },
  { id: 'electrician-service', name: 'Electrician Service', tag: 'Per visit', price: 149, image: ASSETS.electrician, icon: 'Zap' },
];

// Helper: cleaning categories where all sub-services are billed hourly.
const HOURLY_CLEANING = new Set([
  'home-cleaning', 'deep-cleaning', 'office-cleaning', 'apartment-cleaning',
  'glass-cleaning', 'water-tank-cleaning', 'corporate-office', 'showroom-cleaning',
  'apartment-society', 'sofa-cleaning',
]);

export const SERVICES = {
  'electrician-service': {
    title: 'Electrician Services',
    items: [
      { id: 'e1', name: 'Ceiling Fan Installation', basis: 'Per visit', rating: 4.9, reviews: 492, price: 169, oldPrice: 299, desc: 'Labour charges for installation of ceiling, exhaust or wall fan.', image: ASSETS.fanClean, save: 43 },
      { id: 'e2', name: 'Fan repair', basis: 'Per visit', rating: 4.9, reviews: 446, price: 299, oldPrice: 499, desc: 'Labour charges for repair of ceiling, wall or exhaust fan.', image: ASSETS.fanClean, save: 40 },
      { id: 'e3', name: 'Electrical work check-up', basis: 'Per visit', rating: 4.9, reviews: 536, price: 149, oldPrice: 299, desc: 'Book an expert electrician. Actual prices are based on the scope of work.', image: ASSETS.electrician, save: 50 },
      { id: 'e4', name: 'Switchboard repair', basis: 'Per visit', rating: 4.8, reviews: 312, price: 199, oldPrice: 349, desc: 'Repair or replacement of switchboards and switches.', image: ASSETS.switchboard, save: 43 },
      { id: 'e5', name: 'MCB / Fuse replacement', basis: 'Per visit', rating: 4.9, reviews: 221, price: 249, oldPrice: 399, desc: 'Replace faulty MCBs or fuses for safe electrical operation.', image: ASSETS.electrician, save: 37 },
    ],
  },
  'plumber-service': {
    title: 'Plumber Service',
    items: [
      { id: 'p1', name: 'Tap / Faucet Repair', basis: 'Per visit', rating: 4.9, reviews: 388, price: 199, oldPrice: 299, desc: 'Repair or replacement of taps and faucets.', image: ASSETS.plumber, save: 33 },
      { id: 'p2', name: 'Pipe Leakage Fix', basis: 'Per visit', rating: 4.8, reviews: 421, price: 299, oldPrice: 499, desc: 'Diagnose and fix pipe leakages.', image: ASSETS.plumber, save: 40 },
      { id: 'p3', name: 'Toilet Repair', basis: 'Per visit', rating: 4.8, reviews: 276, price: 349, oldPrice: 549, desc: 'Toilet flush and seat repair or replacement.', image: ASSETS.plumber, save: 36 },
    ],
  },
  'home-cleaning': {
    title: 'Home Cleaning',
    items: [
      { id: 'h1', name: 'Full Home Cleaning', basis: 'Hourly', rating: 4.8, reviews: 1240, price: 899, oldPrice: 1299, desc: 'Complete home cleaning including all rooms, kitchen and bathrooms.', image: ASSETS.sinkClean, save: 30 },
      { id: 'h2', name: 'Kitchen Deep Clean', basis: 'Hourly', rating: 4.9, reviews: 892, price: 599, oldPrice: 899, desc: 'Deep cleaning of kitchen surfaces, appliances and floor.', image: ASSETS.dishClean, save: 33 },
      { id: 'h3', name: 'Bathroom Cleaning', basis: 'Hourly', rating: 4.7, reviews: 654, price: 399, oldPrice: 599, desc: 'Thorough scrubbing and sanitisation of bathrooms.', image: ASSETS.toiletClean, save: 33 },
      { id: 'h4', name: 'Bed Making & Linen', basis: 'Hourly', rating: 4.8, reviews: 421, price: 299, oldPrice: 449, desc: 'Bed making, linen change and bedroom tidying.', image: ASSETS.bedChange, save: 33 },
    ],
  },
  'deep-cleaning': {
    title: 'Deep Cleaning',
    items: [
      { id: 'd1', name: 'Full Home Deep Cleaning', basis: 'Hourly', rating: 4.9, reviews: 812, price: 1499, oldPrice: 2299, desc: 'Intensive whole-home deep cleaning with premium chemicals.', image: ASSETS.wallClean, save: 35 },
      { id: 'd2', name: 'Post-Renovation Cleaning', basis: 'Hourly', rating: 4.8, reviews: 214, price: 1999, oldPrice: 2999, desc: 'Remove dust, cement and stains after construction/renovation.', image: ASSETS.wallClean, save: 33 },
      { id: 'd3', name: 'Pre-move-in Deep Clean', basis: 'Hourly', rating: 4.9, reviews: 388, price: 1299, oldPrice: 1899, desc: 'Sparkling clean home before you move in.', image: ASSETS.sinkClean, save: 32 },
    ],
  },
  'office-cleaning': {
    title: 'Office Cleaning',
    items: [
      { id: 'o1', name: 'Small Office Cleaning', basis: 'Hourly', rating: 4.8, reviews: 342, price: 799, oldPrice: 1199, desc: 'Cleaning for offices up to 500 sq. ft.', image: ASSETS.officeCleaning, save: 33 },
      { id: 'o2', name: 'Large Office Cleaning', basis: 'Hourly', rating: 4.7, reviews: 128, price: 1499, oldPrice: 1999, desc: 'Cleaning for offices up to 2000 sq. ft.', image: ASSETS.officeCleaning, save: 25 },
    ],
  },
  'apartment-cleaning': {
    title: 'Apartment Cleaning',
    items: [
      { id: 'a1', name: '1 BHK Apartment', basis: 'Hourly', rating: 4.8, reviews: 512, price: 699, oldPrice: 999, desc: 'Full apartment cleaning for 1 BHK homes.', image: ASSETS.apartmentCleaning, save: 30 },
      { id: 'a2', name: '2 BHK Apartment', basis: 'Hourly', rating: 4.9, reviews: 634, price: 999, oldPrice: 1499, desc: 'Full apartment cleaning for 2 BHK homes.', image: ASSETS.apartmentCleaning, save: 33 },
      { id: 'a3', name: '3 BHK Apartment', basis: 'Hourly', rating: 4.8, reviews: 289, price: 1299, oldPrice: 1899, desc: 'Full apartment cleaning for 3 BHK homes.', image: ASSETS.apartmentCleaning, save: 32 },
    ],
  },
  'glass-cleaning': {
    title: 'Glass Cleaning',
    items: [
      { id: 'g1', name: 'Window Glass Cleaning', basis: 'Hourly', rating: 4.8, reviews: 421, price: 299, oldPrice: 499, desc: 'Interior and exterior window glass cleaning.', image: ASSETS.glassCleaning, save: 40 },
      { id: 'g2', name: 'Balcony Glass Cleaning', basis: 'Hourly', rating: 4.7, reviews: 218, price: 399, oldPrice: 599, desc: 'Balcony glass and railing cleaning.', image: ASSETS.glassCleaning, save: 33 },
    ],
  },
  'water-tank-cleaning': {
    title: 'Water Tank Cleaning',
    items: [
      { id: 'w1', name: 'Overhead Tank (500L)', basis: 'Hourly', rating: 4.9, reviews: 512, price: 599, oldPrice: 899, desc: 'Cleaning & sanitisation of overhead tank up to 500L.', image: ASSETS.waterTank, save: 33 },
      { id: 'w2', name: 'Underground Sump Cleaning', basis: 'Hourly', rating: 4.8, reviews: 328, price: 999, oldPrice: 1499, desc: 'Underground sump cleaning by safety-certified crew.', image: ASSETS.waterTank, save: 33 },
    ],
  },
  'corporate-office': {
    title: 'Corporate Office',
    items: [
      { id: 'c1', name: 'Corporate Daily Cleaning', basis: 'Hourly', rating: 4.9, reviews: 132, price: 2999, oldPrice: 3999, desc: 'Daily cleaning contract for corporate spaces.', image: ASSETS.corporateOffice, save: 25 },
    ],
  },
  'showroom-cleaning': {
    title: 'Showroom Cleaning',
    items: [
      { id: 's1', name: 'Showroom Cleaning', basis: 'Hourly', rating: 4.8, reviews: 92, price: 1499, oldPrice: 1999, desc: 'Detailed showroom cleaning including glass display.', image: ASSETS.showroomCleaning, save: 25 },
    ],
  },
  'apartment-society': {
    title: 'Apartment Society',
    items: [
      { id: 'as1', name: 'Society Common Area', basis: 'Hourly', rating: 4.7, reviews: 68, price: 3999, oldPrice: 5999, desc: 'Cleaning of society common areas, lobby and staircase.', image: ASSETS.apartmentSociety, save: 33 },
    ],
  },
  'sofa-cleaning': {
    title: 'Sofa Cleaning',
    items: [
      { id: 'sc1', name: '3-Seater Sofa Shampoo', basis: 'Hourly', rating: 4.9, reviews: 612, price: 499, oldPrice: 799, desc: 'Deep shampoo cleaning for a standard 3-seater sofa.', image: ASSETS.bedChange, save: 37 },
      { id: 'sc2', name: '5-Seater Sofa Shampoo', basis: 'Hourly', rating: 4.8, reviews: 348, price: 799, oldPrice: 1199, desc: 'Deep shampoo cleaning for a 5-seater sofa set.', image: ASSETS.bedChange, save: 33 },
      { id: 'sc3', name: 'Recliner Cleaning', basis: 'Hourly', rating: 4.8, reviews: 121, price: 399, oldPrice: 599, desc: 'Stain removal and deep clean for recliners.', image: ASSETS.bedChange, save: 33 },
      { id: 'sc4', name: 'Fabric Chair Cleaning', basis: 'Hourly', rating: 4.7, reviews: 89, price: 199, oldPrice: 349, desc: 'Per chair — fabric shampoo and deodorising.', image: ASSETS.bedChange, save: 43 },
    ],
  },
};

export const OFFERS = [
  { id: 'o1', discount: '₹100 OFF', text: '₹100 off orders above ₹499', code: 'FLAT100' },
  { id: 'o2', discount: '₹150 OFF', text: 'Summer special on Deep Cleaning', code: 'SUMMER150' },
  { id: 'o3', discount: '20% OFF', text: '20% off first booking', code: 'FIRST20' },
];

export const CLEANER_STATS = {
  performanceScore: 41,
  status: 'GROWING',
  ratingsMessage: 'No ratings yet',
  breakdown: [
    { label: 'Customer rating', weight: 40, value: 0, max: 100 },
    { label: 'Job completion', weight: 25, value: 100, max: 100 },
    { label: 'On-time arrival', weight: 20, value: 77, max: 100 },
    { label: 'Attendance', weight: 15, value: 4, max: 100 },
  ],
  jobsDone: 13,
  attendance: '1/25',
  onTime: '10/13',
};

export const NEARBY_JOBS = [
  { id: 'j1', service: 'Home Cleaning', address: 'MG Road, Ernakulam', distance: '1.2 km', payout: 450, time: '10:00 AM' },
  { id: 'j2', service: 'Deep Cleaning', address: 'Marine Drive, Ernakulam', distance: '2.4 km', payout: 899, time: '11:30 AM' },
  { id: 'j3', service: 'Fan Repair', address: 'Kaloor, Ernakulam', distance: '3.1 km', payout: 299, time: '2:00 PM' },
];

export { HOURLY_CLEANING };
